 <template>
    <div>
        <order-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                           :paginationData="filterSet.page" :sortData="filterSet.sort"
                           :filterSet="filterSet" :categoryData="categoryData"></order-filter-link>
        <order-list-link ref="orderListLink" :listLayout="listLayout" :orderData="List" :sortData="filterSet.sort"
                         :paginationData="filterSet.page" :orderType="orderType"></order-list-link>
        <pagination-link :pagination-layout="paginationLayout" :paginationData="filterSet.page" :listLength="List.length"
                         :finishGetList="finishGetList" :orderType="orderType" :sortData="filterSet.sort"></pagination-link>
    </div>
</template>

<script>
import OrderFilterLink from "./link/OrderFilterLink";
import OrderListLink from "./link/OrderListLink";
import PaginationLink from "./link/PaginationLink";
import filterMixins from "../../mixins/filterMixins";
import listMixins from "../../mixins/listMixins";
import orderUtil from "./orderUtil";
import orderMixins from "@/mixins/orderMixins";

import util from '@/mixins/util';
import EventBus from "../../mixins/event-bus";

const {filterConfig} = orderUtil
import {setExcelConfig, runExcelDown, runExcelDownByMethod} from "@/mixins/excelApiDown";

export default {
    name: "OrderListComponent",
    mixins: [orderUtil,filterMixins,listMixins,orderMixins],
    components: {PaginationLink, OrderListLink, OrderFilterLink},
    inject: [],
    provide() {
        return {
            setPage: this.setPage,
            setSort: this.setSort,
            setFilter: this.setFilter,
            excelDown : this.excelDown,
            resetFilter :this.getOrderList,
            memberExcelDown: this.memberExcelDown
        }
    },
    props: {
        orderType:'',
        defaultParams: {
            default: () => {
            }
        },
        memberKey:'',
        brandKey:'',
    },
    data() {
        return {
            filterLayout: '',
            listLayout: '',
            emptyLayout: '',
            paginationLayout: '',
            getFunc : '',
            pageRow:10,
            listApiParamSet:{},
            defaultSort: {},
            sortOptions: {},
            paginationType: '',

            isGetFirst:true,
            isCategory:false,
            getCategoryFunc:'',
            categoryData:{},
            categoryApiParamSet:{},

            excelParamSet:{},
            excelDownloadFunc: 'order',
            excelDownloadName: '',
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        if(this.isGetFirst){
            this.getList(true);
        }
        EventBus.$on('resetOrderData',this.getList)
    },
    beforeDestroy() {
        EventBus.$off('resetOrderData')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initConfig() {
            let config = this.returnOrderConfig(this.orderType)
            this.filterLayout = config.filterLayout;
            this.listLayout = config.listLayout;
            this.emptyLayout = config.emptyLayout;
            this.paginationLayout = config.paginationLayout;

            this.getFunc = config.getFunc;
            this.listApiParamSet = config.listApiParamSet;
            this.pageRow = config.pageRow;

            this.defaultSort = config.defaultSort;
            this.sortOptions = config.sortOptions;

            this.paginationType = config.paginationType;
            this.isGetFirst= config.isGetFirst;
            this.isCategory = config.isCategory;
            this.getCategoryFunc = config.getCategoryFunc;
            this.categoryApiParamSet = config.categoryApiParamSet;

            this.excelDownloadFunc = config.excelDownloadFunc ?? 'order';
            this.excelDownloadName = config.excelDownloadName
            this.excelParamSet = config.excelParamSet

            //setExcelConfig(this.excelDownloadFunc, this.excelDownloadName)

            this.setSortOptions(this.sortOptions, this.defaultSort);

            if (this.pageRow != this.filterSet.page.size) {
                this.filterSet.page.size = this.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }
            let params = Object.assign({}, this.listApiParamSet, this.defaultParams);
            if(this.orderType == 'memberOrderHistory'){
                params.no = this.memberKey
            }
            if(this.orderType == 'brandOrderHistory'){
                params.bid = this.brandKey
            }

            let listOptions = {
                url: this.$api.$order[this.getFunc],
                defaultParams: params,
            }
            this.initList('api', listOptions);

            if(this.isCategory){
                this.getCategory()
            }
        },
        getOrderList(){
            this.resetFilter()
            this.getList()
        },
        getCategory(){
            if(util.isEmpty(this.getCategoryFunc)){
                return false
            }
            let params = Object.assign({}, this.categoryApiParamSet);
            try{
                this.$api.$order[this.getCategoryFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.status) {
                        this.categoryData = res.List;
                    }
                })
            }catch (e){
                console.log(e)
            }
        },
        excelDown(){
            let params = JSON.parse(JSON.stringify(this.excelParamSet));
            let makeParams = this.makeParams(this.filterSet);
            params = Object.assign(params, makeParams);
            params.bid = this.brandKey
            setExcelConfig(this.excelDownloadFunc, this.excelDownloadName)
            // setExcelConfig('order', this.excelDownloadName)
            runExcelDownByMethod(params, 'get')
        },
        memberExcelDown(){
            let params = JSON.parse(JSON.stringify(this.excelParamSet));
            let makeParams = this.makeParams(this.filterSet);
            params = Object.assign(params, makeParams);
            // let params = this.makeParams(this.filterSet); // 필터 데이터 전부 동기화
            // params = Object.assign(params, this.excelParamSet)
            params.no = this.memberKey
            setExcelConfig(this.excelDownloadFunc, this.excelDownloadName)
            //setExcelConfig('order', this.excelDownloadName)
            runExcelDownByMethod(params, 'get')
        },
        makeParams(filterSet) {
            let returnParams = {}
            let filterList = Object.values(filterSet.filter);
            filterList.forEach(obj => {
                returnParams = this.setFilterParamValue(returnParams, obj);
            });
            if(filterSet.sort.hasOwnProperty('key') && filterSet.sort.hasOwnProperty('order')) {
                if(filterSet.sort.option.hasOwnProperty('keyName')) {
                    returnParams[filterSet.sort.option.keyName] = filterSet.sort.key
                }else{
                    returnParams.orderByType = filterSet.sort.key;
                }

                if(filterSet.sort.option.hasOwnProperty('orderName')) {
                    returnParams[filterSet.sort.option.orderName] = filterSet.sort.order
                }else{
                    returnParams.orderBySort = filterSet.sort.order;
                }
            }
            return returnParams;
        },

        setFilterParamValue(params, obj) {
            if(obj.hasOwnProperty('query')) {
                params[obj.key] = obj.query;
            }else if(obj.hasOwnProperty('value')) {
                if(obj.key != 'tab') {
                    if(!obj.option || !obj.option[obj.value]) {
                        params[obj.key] = obj.value;
                    }else{
                        params = Object.assign({}, params, obj.option[obj.value]);
                    }
                }
            }else if(obj.hasOwnProperty('start') && obj.hasOwnProperty('end')) {
                if(!obj.option.start && obj.start != "") {
                    params[obj.key+'sd'] = obj.start;
                }else if(obj.start != ''){
                    params[obj.option.start] = obj.start;
                }
                if(!obj.option.end && obj.end != "") {
                    params[obj.key+'ed'] = obj.end;
                }else if(obj.end != ''){
                    params[obj.option.end] = obj.end;
                }
            }else if(obj.hasOwnProperty('terms')) {
                let keyName = "";
                if(!obj.option.keyName && obj.option.keyName != undefined) {
                    keyName = obj.option.keyName;
                }else{
                    keyName = obj.key;
                }
                params[keyName] = [];
                for (let i = 0; i<obj.terms.length; i++) {
                    if(!obj.option || !obj.option[obj.terms[i]]) {
                        params[keyName].push(obj.terms[i])
                    }else{
                        if(params[keyName].length === 0) {
                            params[keyName] = obj.option[obj.terms[i]].slice();
                        }else{
                            params[keyName] = params[keyName].concat(obj.option[obj.terms[i]]);
                        }

                    }
                }
            }
            return params;
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
